import React from 'react';
import { testId } from '../../../../utils/testIds';
import { RENDER_MODE } from '../../constants';

function StringField({ config, value, onChange, onBlur, disabled, required, error, renderMode }) {
  const displayValue = value ?? '';

  const handleChange = e => {
    const next = e.target.value;
    onChange(config.maxLength ? next.slice(0, config.maxLength) : next);
  };

  if (renderMode === RENDER_MODE.CARD || renderMode === RENDER_MODE.GRID) {
    return (
      <span className="field-engine-string-value">
        {displayValue || <span className="field-engine-empty">—</span>}
      </span>
    );
  }

  if (renderMode === RENDER_MODE.DETAIL) {
    return (
      <input
        id={config.fieldKey}
        data-test={testId('field', config.fieldKey, 'input')}
        name={config.fieldKey}
        type="text"
        className={`field-engine-input field-engine-input--string${error ? ' field-engine-input--error' : ''}`}
        value={displayValue}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={disabled}
        aria-invalid={!!error}
        aria-describedby={error ? `${config.fieldKey}-error` : undefined}
        maxLength={config.maxLength || undefined}
      />
    );
  }

  return (
    <input
      id={config.fieldKey}
      data-test={testId('field', config.fieldKey, 'input')}
      name={config.fieldKey}
      type="text"
      className={`field-engine-input field-engine-input--string${error ? ' field-engine-input--error' : ''}${disabled ? ' disabled' : ''}`}
      value={displayValue}
      onChange={handleChange}
      onBlur={onBlur}
      disabled={disabled}
      required={required}
      aria-required={required}
      aria-invalid={!!error}
      aria-describedby={error ? `${config.fieldKey}-error` : undefined}
      placeholder={config.fieldSettings?.placeholder ?? config.label ?? ''}
      maxLength={config.maxLength || undefined}
    />
  );
}

export default StringField;
